// Single source of truth (frontend) for the thumbnail image rule: an image must
// be exactly 16:9 (no tolerance) and at least 1280x720. Mirrors the backend
// App\Service\Image\AspectRatioConformance.

export const THUMBNAIL_MIN_WIDTH = 1280;
export const THUMBNAIL_MIN_HEIGHT = 720;

export const THUMBNAIL_CONSTRAINT_TEXT =
  "This image does not meet the required constraints. Thumbnails must be exactly 16:9 and at least 1280×720 (e.g. 1280×720, 1920×1080, 3840×2160).";

export function isSixteenNineConforming(
  width: number,
  height: number,
): boolean {
  if (!width || !height || width <= 0 || height <= 0) {
    return false;
  }
  if (width < THUMBNAIL_MIN_WIDTH || height < THUMBNAIL_MIN_HEIGHT) {
    return false;
  }
  // Exact 16:9 with no leeway: width/height === 16/9  <=>  width*9 === height*16.
  return width * 9 === height * 16;
}

export function getImageDimensions(
  url: string,
): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () =>
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = () => reject(new Error("Failed to load image"));
    img.src = url;
  });
}
